import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _merge from "lodash/merge.js";
import _map from "lodash/map.js";
function cov_qwpydvadc() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/GoogleMapDisplay/GoogleMapDisplay.tsx";
  var hash = "b6fa0291a0ab3c65e3603944f87b29e1dff680d1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/GoogleMapDisplay/GoogleMapDisplay.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 54,
          column: 75
        }
      },
      "2": {
        start: {
          line: 54,
          column: 50
        },
        end: {
          line: 54,
          column: 74
        }
      },
      "3": {
        start: {
          line: 57,
          column: 31
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "4": {
        start: {
          line: 71,
          column: 17
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "5": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 98
        }
      },
      "6": {
        start: {
          line: 76,
          column: 57
        },
        end: {
          line: 76,
          column: 96
        }
      },
      "7": {
        start: {
          line: 80,
          column: 89
        },
        end: {
          line: 80,
          column: 99
        }
      },
      "8": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "9": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 44
        }
      },
      "10": {
        start: {
          line: 86,
          column: 17
        },
        end: {
          line: 86,
          column: 18
        }
      },
      "11": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      },
      "12": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 44
        }
      },
      "13": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 103,
          column: 6
        }
      },
      "14": {
        start: {
          line: 106,
          column: 35
        },
        end: {
          line: 123,
          column: 3
        }
      },
      "15": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "16": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "17": {
        start: {
          line: 110,
          column: 30
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "18": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 122,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 54,
            column: 40
          }
        },
        loc: {
          start: {
            line: 54,
            column: 50
          },
          end: {
            line: 54,
            column: 74
          }
        },
        line: 54
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 75,
            column: 29
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 75
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 76,
            column: 51
          },
          end: {
            line: 76,
            column: 52
          }
        },
        loc: {
          start: {
            line: 76,
            column: 57
          },
          end: {
            line: 76,
            column: 96
          }
        },
        line: 76
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 18
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 79
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 106,
            column: 35
          },
          end: {
            line: 106,
            column: 36
          }
        },
        loc: {
          start: {
            line: 106,
            column: 75
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 106
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 81
      },
      "1": {
        loc: {
          start: {
            line: 82,
            column: 13
          },
          end: {
            line: 82,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 26
          },
          end: {
            line: 82,
            column: 36
          }
        }, {
          start: {
            line: 82,
            column: 39
          },
          end: {
            line: 82,
            column: 43
          }
        }],
        line: 82
      },
      "2": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 87
      },
      "3": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 39
          }
        }, {
          start: {
            line: 87,
            column: 43
          },
          end: {
            line: 87,
            column: 69
          }
        }],
        line: 87
      },
      "4": {
        loc: {
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 99,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 99,
            column: 21
          }
        }, {
          start: {
            line: 99,
            column: 25
          },
          end: {
            line: 99,
            column: 81
          }
        }],
        line: 99
      },
      "5": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 107
      },
      "6": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 32
          }
        }, {
          start: {
            line: 107,
            column: 36
          },
          end: {
            line: 107,
            column: 55
          }
        }],
        line: 107
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b6fa0291a0ab3c65e3603944f87b29e1dff680d1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qwpydvadc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_qwpydvadc();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import { Box } from '@opendoor/bricks/core';
import { Loader } from '@opendoor/bricks/core/Loader';
import ensureGoogle from "../AddressInput/ensureGoogleMaps.mjs";
var DEFAULT_OPTIONS = (cov_qwpydvadc().s[0]++, {
  gestureHandling: 'none',
  mapTypeControl: false,
  streetViewControl: false,
  zoom: 15,
  zoomControl: false
});
var WrappedGoogleMap = (cov_qwpydvadc().s[1]++, withGoogleMap(function (props) {
  cov_qwpydvadc().f[0]++;
  cov_qwpydvadc().s[2]++;
  return /*#__PURE__*/React.createElement(GoogleMap, props);
}));
var GoogleMapDisplay = /*#__PURE__*/function (_React$Component) {
  function GoogleMapDisplay() {
    var _this;
    _classCallCheck(this, GoogleMapDisplay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GoogleMapDisplay, [].concat(args));
    _defineProperty(_this, "state", (cov_qwpydvadc().s[4]++, {
      googleIsLoaded: false
    }));
    _defineProperty(_this, "renderAdditionalMarker", (cov_qwpydvadc().s[14]++, function (markerData, index) {
      cov_qwpydvadc().f[4]++;
      cov_qwpydvadc().s[15]++;
      if ((cov_qwpydvadc().b[6][0]++, markerData === undefined) || (cov_qwpydvadc().b[6][1]++, markerData === null)) {
        cov_qwpydvadc().b[5][0]++;
        cov_qwpydvadc().s[16]++;
        return;
      } else {
        cov_qwpydvadc().b[5][1]++;
      }
      var position = (cov_qwpydvadc().s[17]++, {
        lat: markerData.lat,
        lng: markerData.lng
      });
      cov_qwpydvadc().s[18]++;
      return /*#__PURE__*/React.createElement(Marker, {
        key: index,
        position: position,
        label: markerData.label,
        icon: markerData.icon,
        zIndex: index
      });
    }));
    return _this;
  }
  _inherits(GoogleMapDisplay, _React$Component);
  return _createClass(GoogleMapDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      cov_qwpydvadc().f[1]++;
      cov_qwpydvadc().s[5]++;
      ensureGoogle(this.props.googleMapsApiKey).then(function () {
        cov_qwpydvadc().f[2]++;
        cov_qwpydvadc().s[6]++;
        return _this2.setState({
          googleIsLoaded: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_qwpydvadc().f[3]++;
      var _ref = (cov_qwpydvadc().s[7]++, this.props),
        center = _ref.center,
        height = _ref.height,
        icon = _ref.icon,
        options = _ref.options,
        showLoader = _ref.showLoader,
        showMarker = _ref.showMarker,
        additionalMarkers = _ref.additionalMarkers;
      cov_qwpydvadc().s[8]++;
      if (!this.state.googleIsLoaded) {
        cov_qwpydvadc().b[0][0]++;
        cov_qwpydvadc().s[9]++;
        return showLoader ? (cov_qwpydvadc().b[1][0]++, /*#__PURE__*/React.createElement(Loader, null)) : (cov_qwpydvadc().b[1][1]++, null);
      } else {
        cov_qwpydvadc().b[0][1]++;
      }

      // always ensure primary marker's z-index is greater than any additional markers
      var zIndex = (cov_qwpydvadc().s[10]++, 0);
      cov_qwpydvadc().s[11]++;
      if ((cov_qwpydvadc().b[3][0]++, additionalMarkers !== undefined) && (cov_qwpydvadc().b[3][1]++, additionalMarkers !== null)) {
        cov_qwpydvadc().b[2][0]++;
        cov_qwpydvadc().s[12]++;
        zIndex = additionalMarkers.length + 1;
      } else {
        cov_qwpydvadc().b[2][1]++;
      }
      cov_qwpydvadc().s[13]++;
      return /*#__PURE__*/React.createElement(Box, {
        height: height
      }, /*#__PURE__*/React.createElement(WrappedGoogleMap, {
        defaultCenter: center,
        defaultOptions: _merge(DEFAULT_OPTIONS, options),
        containerElement: /*#__PURE__*/React.createElement("div", {
          style: {
            height: '100%'
          }
        }),
        mapElement: /*#__PURE__*/React.createElement("div", {
          style: {
            height: '100%'
          }
        })
      }, (cov_qwpydvadc().b[4][0]++, showMarker) && (cov_qwpydvadc().b[4][1]++, /*#__PURE__*/React.createElement(Marker, {
        position: center,
        icon: icon,
        zIndex: zIndex
      })), _map(additionalMarkers, this.renderAdditionalMarker)));
    }
  }]);
}((React.Component));
_defineProperty(GoogleMapDisplay, "defaultProps", (cov_qwpydvadc().s[3]++, {
  height: '100%',
  icon: {
    scaledSize: {
      height: 50,
      width: 39.29
    },
    url: 'https://imgdrop.imgix.net/b3fbee3036754d1a8dcf2b03a31d471c.png'
  },
  options: {},
  showLoader: false,
  showMarker: true
}));
export { GoogleMapDisplay as default };
//# sourceMappingURL=GoogleMapDisplay.mjs.map